var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 14.5H9.16667C8.98448 14.5 8.83333 14.3489 8.83333 14.1667C8.83333 13.9845 8.98448 13.8333 9.16667 13.8333H10.8333C11.0155 13.8333 11.1667 13.9845 11.1667 14.1667C11.1667 14.3489 11.0155 14.5 10.8333 14.5ZM3.33333 6.16667C3.15114 6.16667 3 6.01552 3 5.83333C3 5.65114 3.15114 5.5 3.33333 5.5H16.6667C16.8489 5.5 17 5.65114 17 5.83333C17 6.01552 16.8489 6.16667 16.6667 6.16667H3.33333ZM14.1667 10.3333H5.83333C5.65114 10.3333 5.5 10.1822 5.5 10C5.5 9.81781 5.65114 9.66667 5.83333 9.66667H14.1667C14.3489 9.66667 14.5 9.81781 14.5 10C14.5 10.1822 14.3489 10.3333 14.1667 10.3333Z",
    fill: "#323232",
    stroke: "#2B8C34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterList);
export default __webpack_public_path__ + "static/media/filter_list.7c73f8701dd73147d6d4e91c3a7beded.svg";
export { ForwardRef as ReactComponent };